import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import SccRemoteImage from '@/components/SccRemoteImage';
import FlagIcon from '@/assets/icon/ic_flag_colored.svg';
import ProfileBuggyIcon from '@/assets/icon/ic_profile_buggy.svg';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import { useMe } from '@/atoms/Auth';
export default function V2ConquerorTab({ accessibility, onPressRegister, }) {
    var _a, _b, _c, _d, _e, _f;
    const { userInfo } = useMe();
    const nickname = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.nickname) || '회원';
    const hasAnyInfo = !!(accessibility === null || accessibility === void 0 ? void 0 : accessibility.placeAccessibility) ||
        !!(accessibility === null || accessibility === void 0 ? void 0 : accessibility.buildingAccessibility) ||
        ((_b = (_a = accessibility === null || accessibility === void 0 ? void 0 : accessibility.placeAccessibilities) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 ||
        ((_d = (_c = accessibility === null || accessibility === void 0 ? void 0 : accessibility.buildingAccessibilities) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
    if (!hasAnyInfo) {
        return (_jsxs(EmptyStateContainer, { children: [_jsxs(EmptyStateTextBlock, { children: [_jsx(EmptyStateTitle, { children: "\uC774 \uC7A5\uC18C\uC758 \uC815\uBCF5\uC790\uAC00 \uC544\uC9C1 \uC5C6\uC5B4\uC694" }), _jsx(EmptyStateDescription, { children: `지금 바로 정보를 등록하시면\n${nickname}님이 첫번째 정복자 되실 수 있어요!` })] }), _jsxs(EmptyStateCTAButton, { elementName: "v2_conqueror_tab_empty_register", onPress: onPressRegister, children: [_jsx(FlagIcon, { width: 20, height: 20 }), _jsx(EmptyStateCTAText, { children: "\uC815\uBCF4 \uB4F1\uB85D\uD558\uACE0 \uCCAB\uBC88\uC9F8 \uC815\uBCF5\uC790\uAC00 \uB418\uAE30!" })] })] }));
    }
    const rawCrushers = [];
    // 배열(V2)에서 모든 정복자 수집, 없으면 singular fallback
    const placeItems = ((_e = accessibility === null || accessibility === void 0 ? void 0 : accessibility.placeAccessibilities) === null || _e === void 0 ? void 0 : _e.length)
        ? accessibility.placeAccessibilities
        : (accessibility === null || accessibility === void 0 ? void 0 : accessibility.placeAccessibility)
            ? [accessibility.placeAccessibility]
            : [];
    for (const pa of placeItems) {
        if (pa.registeredUserName) {
            rawCrushers.push({
                name: pa.registeredUserName,
                source: 'place',
                challengeCrusherGroup: pa.challengeCrusherGroup
                    ? { icon: pa.challengeCrusherGroup.icon }
                    : undefined,
            });
        }
    }
    const buildingItems = ((_f = accessibility === null || accessibility === void 0 ? void 0 : accessibility.buildingAccessibilities) === null || _f === void 0 ? void 0 : _f.length)
        ? accessibility.buildingAccessibilities
        : (accessibility === null || accessibility === void 0 ? void 0 : accessibility.buildingAccessibility)
            ? [accessibility.buildingAccessibility]
            : [];
    for (const ba of buildingItems) {
        if (ba.registeredUserName) {
            rawCrushers.push({
                name: ba.registeredUserName,
                source: 'building',
                challengeCrusherGroup: ba.challengeCrusherGroup
                    ? { icon: ba.challengeCrusherGroup.icon }
                    : undefined,
            });
        }
    }
    // 동일 정복자 중복 제거 (이름 기준, challengeCrusherGroup은 먼저 나온 것 유지)
    const seen = new Set();
    const crushers = rawCrushers.filter(c => {
        if (seen.has(c.name)) {
            return false;
        }
        seen.add(c.name);
        return true;
    });
    return (_jsx(Container, { children: crushers.map((crusher, index) => (_jsxs(React.Fragment, { children: [index > 0 && _jsx(RowDivider, {}), _jsxs(CrusherRow, { children: [_jsx(ProfileIconContainer, { children: _jsx(ProfileBuggyIcon, { width: 18, height: 20.75 }) }), _jsx(UserName, { children: crusher.name })] }), crusher.challengeCrusherGroup && (_jsxs(B2BLabelContainer, { children: [crusher.challengeCrusherGroup.icon && (_jsx(SccRemoteImage, { imageUrl: crusher.challengeCrusherGroup.icon.imageUrl, resizeMode: "contain", wrapperBackgroundColor: null, fixedHeight: 17 })), _jsx(B2BText, { children: "\uC774 \uACC4\uB2E8\uBFCC\uC154\uD074\uB7FD\uACFC \uD568\uAED8\uD588\uC5B4\uC694." })] }))] }, `${crusher.source}-${index}`))) }));
}
// ──────────────── 스타일 ────────────────
const Container = styled.View `
  flex: 1;
  background-color: ${color.white};
`;
const CrusherRow = styled.View `
  padding-horizontal: 20px;
  min-height: 72px;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;
const ProfileIconContainer = styled.View `
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background-color: ${color.gray10};
  border-width: 1px;
  border-color: ${color.gray20};
  align-items: center;
  justify-content: center;
`;
const UserName = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 15px;
  line-height: 22px;
  color: ${color.gray90};
`;
const RowDivider = styled.View `
  height: 1px;
  background-color: ${color.gray20};
`;
const B2BLabelContainer = styled.View `
  background-color: ${color.gray15};
  border-radius: 5px;
  height: 34px;
  margin-horizontal: 20px;
  margin-top: 0px;
  margin-bottom: 12px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2px;
`;
const B2BText = styled.Text `
  font-family: ${font.pretendardRegular};
  font-size: 14px;
  line-height: 20px;
  color: #6a6a73;
`;
// Empty state
const EmptyStateContainer = styled.View `
  flex: 1;
  background-color: ${color.gray5};
  padding-top: 40px;
  padding-horizontal: 20px;
  padding-bottom: 20px;
  gap: 16px;
`;
const EmptyStateTextBlock = styled.View `
  gap: 8px;
  align-items: center;
`;
const EmptyStateTitle = styled.Text `
  font-family: ${font.pretendardSemibold};
  font-size: 18px;
  line-height: 26px;
  letter-spacing: -0.36px;
  color: ${color.gray80};
  text-align: center;
`;
const EmptyStateDescription = styled.Text `
  font-family: ${font.pretendardRegular};
  font-size: 15px;
  line-height: 24px;
  letter-spacing: -0.3px;
  color: ${color.gray50};
  text-align: center;
`;
const EmptyStateCTAButton = styled(SccTouchableOpacity) `
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background-color: ${color.white};
  border-width: 1px;
  border-color: ${color.brand40};
  border-radius: 8px;
  padding-vertical: 12px;
  padding-horizontal: 28px;
`;
const EmptyStateCTAText = styled.Text.attrs({
    style: { includeFontPadding: false, textAlignVertical: 'center' },
}) `
  font-family: ${font.pretendardSemibold};
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.32px;
  color: ${color.brand40};
`;
